import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';

import AppBarButton from '../AppBarButton';

export const AppBarMenuButtonContext = React.createContext();

const AppBarMenuButton = ({ title, vertical = 'top', horizontal = 'center', children }) => {

    const [anchor, setAnchor] = useState(null);
    const handleOpenMenu = (event) => {
        event.preventDefault();
        if (anchor) {
            setAnchor(null)
        } else {
            setAnchor(event.currentTarget)
        }
    }
    const handleClose = () => setAnchor(null);

    return (
        <AppBarMenuButtonContext.Provider value={{ handleClose }}>
            <Box>
                <AppBarButton onClick={handleOpenMenu} disableTouchRipple href='/' py={0} sx={{ zIndex: anchor ? 9999 : undefined }}>
                    {title}
                </AppBarButton>
                <Menu
                    slotProps={{
                        backdrop: {
                            sx: {
                                backgroundColor: 'rgba(0, 0, 0, 0.4)'
                            }
                        }
                    }}
                    sx={{ mt: '45px', borderRadius: '0px', overflow: 'visible' }}
                    id="menu-appbar"
                    anchorEl={anchor}
                    anchorOrigin={{ vertical, horizontal }}
                    transformOrigin={{ vertical, horizontal }}
                    open={Boolean(anchor)}
                    onClose={handleClose}
                >
                    {children}
                </Menu>
            </Box>
        </AppBarMenuButtonContext.Provider>
    );
}
export default AppBarMenuButton;
